import { Component, Pipe, PipeTransform, ViewChild } from "@angular/core";
import { BusinessDevelopmentContactRoleModel, IBusinessDevelopmentContactRoleModel } from "@models";
import { SlickDialogComponent } from "slick-components";
import { LookupService, SleepService } from "@services";

@Component({
    selector: "business-development-contact-roles-dialog",
    templateUrl: "business-development-contact-roles-dialog.component.html",
    standalone: false
})
export class BusinessDevelopmentContactRolesComponent {
	@ViewChild("dialogRef") dialogRef: SlickDialogComponent;
	resolve: any;

	isSubmitted: boolean = false;
	spinnerStatus: string;
	roles: IBusinessDevelopmentContactRoleModel[] = [];

	constructor(private lookupService: LookupService) {
	}

	async showDialog(): Promise<IBusinessDevelopmentContactRoleModel[]> {
		this.isSubmitted = false;
		this.spinnerStatus = "reset";
		this.roles = null;

		return new Promise<IBusinessDevelopmentContactRoleModel[]>(async (resolve) => {
			this.roles = await this.lookupService.getBusinessDevelopmentContactRoles();			
			this.resolve = resolve;

			this.dialogRef.showDialog();
		});
	}

	addNewRole() {
		this.roles = [...this.roles, new BusinessDevelopmentContactRoleModel()];
	}

	async onSave() {
		this.isSubmitted = true;
		let isValid = true;

		this.roles = this.roles.filter(x => x.businessDevelopmentContactRoleId > 0 || (x.businessDevelopmentContactRoleId === 0 && x.roleName));

		this.roles.forEach(role => {
			if (role.businessDevelopmentContactRoleId > 0 && !role.roleName)
				isValid = false;
		});

		if (!isValid) {
			this.spinnerStatus = "error";
			return;
		}

		try {
			this.spinnerStatus = "spin";

			await SleepService.sleep(500);
			this.roles = await this.lookupService.updateBusinessDevelopmentContactRoles(this.roles);

			this.spinnerStatus = "ok";
			await SleepService.sleep(500);

			this.resolve(this.roles);
			this.dialogRef.hideDialog();
		}
		catch {
			this.spinnerStatus = "error";
		}
	}

	async onCancel() {
		this.resolve(null);
		this.dialogRef.hideDialog();
	}
}

